<template>
  <div class="front-dzslist">
    <div class="searchClassPos">
      <div class="searchClassPos-content">
        <el-input placeholder="请输入内容" v-model="searchForm.bookName" clearable>
          <template slot="prepend">
            <el-popover
              placement="bottom"
              title="高级检索"
              width="600"
              trigger="click">
              <div style="padding: 20px">
                <el-form ref="searchForm" :model="searchForm" label-width="140px">
                  <el-form-item label="搜索关键字">
                    <el-input v-model="searchForm.keyWordEq" clearable="clearable"></el-input>
                  </el-form-item>
                  <el-form-item label="标题">
                    <el-input v-model="searchForm.bookName" clearable="clearable"></el-input>
                  </el-form-item>
                  <el-form-item label="所属分类">
                    <el-select v-model="searchForm.typeId" @change="changeTypeId($event)" placeholder="请选择">
                      <el-option
                        v-for="item in videoTypeList"
                        :label="item.typeName"
                        :key="item.id"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="作者">
                    <el-input v-model="searchForm.author" clearable="clearable"></el-input>
                  </el-form-item>
                  <el-form-item label="出版社">
                    <el-input v-model="searchForm.press" clearable="clearable"></el-input>
                  </el-form-item>
                  <el-form-item label="发布日期">
                    <el-date-picker
                      v-model="searchForm.dateRange"
                      type="daterange"
                      align="right"
                      unlink-panels
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-form-item>
                  <div style="text-align: center">
                    <el-button type="primary" @click="loadEbookTypeList">高级搜索</el-button>
                  </div>
                </el-form>
              </div>
              <el-button slot="reference">高级检索</el-button>
            </el-popover>
          </template>
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="loadEbookTypeList">搜索</el-button>
      </div>

    </div>
    <div class="tool-bar">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in barImgList" :key="item.url">
          <img :src="item.url" :title="item.title" width="100%" height="500px">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="aimcontent-splistmore">
      <div style=" text-align: left; margin: 0 auto; width: 1100px; padding-top: 10px">
        <span style="font-size: 16px">当前位置：</span>
        <span style="color: blue; font-size: 16px; cursor: default;" @click="backToHomePage">首页</span>
        <span style="color: blue; font-size: 16px"> > 视频</span>
      </div>

      <div class="spTabList" v-for="(typeItem,index) in bookTypeList" :key="typeItem.id" >
        <div style="width: 100%; height: 40px"></div>
        <div style="width: 100%;display: flex; justify-content: space-between">
          <div style="display: flex; align-items: center">
            <img src="../../assets/images/left_icon.png" width="51" height="30">
            <span style="margin-left: 15px; font-size: 26px; color: #3372EF; font-weight: bold">{{typeItem.typeName}}</span>
          </div>

        </div>
        <div v-for="item in bookTypeList[index].videoList" :key="item.id"
             class="cardInfolistmore"
             @click="getDetail(item.id)"
        >
          <div style="display: flex; align-items: center; justify-content: space-around;">
            <img :src="item.coverUrl" :title="item.title" width="230" height="128">
          </div>
          <div style="margin-top: 20px; display: flex; flex-direction: column; text-align: left; line-height: 25px">
            <span style="font-weight: bolder; color: #3372EF; font-size: 16px">
                  {{item.title}}
            </span>
            <span style="font-size: 14px">
                  制片人：{{item.author}}
            </span>
            <span style="font-size: 14px">
                  制作单位：{{item.press}}
            </span>
          </div>
        </div>
      </div>
      <div class="pageDiv">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next,total"
          :current-page.sync="nowPage"
          :page-size="pageSize"
          prev-text="上一页"
          next-text="下一页"
          :total="totalCount">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
  import { qryVideoTypeList,qryVideoList } from '../../request/api';

  export default {
    name: 'front',
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        current:0,
        nowPage: 1,
        pageSize: 20,
        totalCount: 0,
        searchForm: {
          bookName: '',
          dateRange: '',
          typeId: this.$route.query.typeId,
          typeName: this.$route.query.typeName,
          keyWordEq: '',
          keyWordLike:'',
          author:'',
          press:''
        },
        bookTypeList:[],
        videoTypeList:[],
        searchKeyWord: "",
        dialogFormVisible: false,
        formLabelWidth: '100px',
        barImgList: [
          {url: require("../../assets/toolbar/01bg.png"), title: "第一个图"},
          {url: require("../../assets/toolbar/02bg.png"), title: "第二个图"},
          {url: require("../../assets/toolbar/03bg.png"), title: "第三个图"},
          {url: require("../../assets/toolbar/04bg.png"), title: "第四个图"},
        ],
        sptjList: [

        ],
        aboutUs: "发文案违法无法额服务阿发文案违法微风万丰奥微风安慰安防慰安妇挖坟安慰法微风安慰法违法未发文发未发文发未发文发未发违法未发完\n" +
          "        发文案违法无法额服务阿发文案违法微风万丰奥微风安慰安防慰安妇挖坟安慰法微风安慰法违法未发文发未发文发未发文发未发违法未发完\n" +
          "        发文案违法无法额服务阿发文案违法微风万丰奥微风安慰安防慰安妇挖坟安慰法微风安慰法违法未发文发未发文发未发文发未发违法未发完\n" +
          "        发文案违法无法额服务阿发文案违法微风万丰奥微风安慰安防慰安妇挖坟安慰法微风安慰法违法未发文发未发文发未发文发未发违法未发完",
        serviceItem: "提供博士硕士论文博士后文件",
        avatar: require("../../assets/avatar.png"),
        msg: 'Welcome to Your Vue.js App',
        telephone: "0078125400",
        position: "上海市杨浦区翔殷路800号",
        form: {
          userName: this.$route.params.userName,
          birth: this.$route.params.birth,
          sex: this.$route.params.sex,
          home: this.$route.params.home,
          aboutUs: this.$route.params.aboutUs
        },
        visible: false
      }
    },
    methods: {
      logout() {
        localStorage.removeItem("token");
        // 管理员页面
        this.$router.push('/');
      },
      handleEdit() {
        this.dialogFormVisible = true;
        //this.form.userName = this.$route.params.userInfo.userName;

      },
      toSecondPage(routerUrl) {
        this.$router.push(routerUrl);
      },
      loadVideoTypeList(){
        let param = {
          containAll: true,
        }
        qryVideoTypeList(param).then(
          resp => {
            if (resp.code === 1) {
              this.videoTypeList = resp.data;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      backToHomePage() {
        this.$router.push("/front/home")
      },
      loadEbookTypeList(){
        let typeId = this.searchForm.typeId
        let typeName = this.searchForm.typeName
        if (this.videoTypeList.length > 0) {
          typeName = this.videoTypeList.find(val=>val.id === typeId).typeName
        }

        let typeInfo = {
          typeName : typeName,
          id : typeId,
          videoList : []
        }
        this.bookTypeList = [typeInfo];
        // 渲染推荐信息
        this.bookTypeList.forEach(value => {
          let param = {
            nowPage: this.nowPage,
            pageSize: this.pageSize,
            typeId: value.id
          }
          qryVideoList(param).then(
            resp1 => {
              if (resp1.code === 1) {
                // 渲染数据
                value["videoList"] = resp1.data.dataList;
                // 添加分页
                this.totalCount = resp1.data.totalCount
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })
        })
      },
      /**
       * 页码点击事件
       */
      handleCurrentChange (val) {
        // 清空之前状态
        this.sptjList = []
        this.nowPage = val
        this.loadEbookTypeList()
      },
      /**
       *  获取详情
       */
      getDetail(id) {
        this.$router.push({name:"SpDetailPageIndex",query:{videoId:id}})
      },
      // 获取更多
      getMoreData(typeId) {
        this.$router.push({name:"SpListMorePageIndex",query:{typeId:typeId}})
      }
    },
    mounted() {
      // 加载书籍分类列表
      this.loadVideoTypeList();
      this.loadEbookTypeList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .front-dzslist {
    width: 100%;
    min-width: 1500px;
    max-width: 1920px;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .top {
    width: 100%;
    height: 42px;
    background-image: url("../../assets/images/top_bg.png");
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .dialogClass{
    min-width: 720px;
  }

  .footer {
    width: 100%;
    height: 199px;
    background-image: url("../../assets/images/down_porfile_bg.png");
  }

  .tool-bar {
    width: 100%;
    height: 500px;
    position: absolute;
    top: 50px;
    z-index: 1;
  }

  .tool-bar .el-carousel__container {
    height: 500px
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .aimcontent-splistmore {
    margin-top: 500px;
    width: 100%;
    height: 1900px;
    background-image: url("../../assets/images/bg@2x.png");
  }

  .a {
    position: absolute;
  }

  .b {
    position: absolute;
  }

  .left-but:hover {
    .b {
      display: block
    }

    .a {
      display: none
    }
  }

  .c {
    position: absolute;
  }

  .d {
    position: absolute;
  }

  .right-but:hover {
    .d {
      display: block
    }

    .c {
      display: none
    }
  }

  .pageWord {
    margin: 0 auto;
    width: 1100px;
    margin-top: 20px;
    text-align: left;

  }

  .pageWord span {
    font-size: 18px;
    line-height: 25px;
    margin-left: 5px
  }

  li a:hover{color:#3372EF}

  .active{
    color: #3372EF;
  }

  .pageDiv {
    width: 1100px;
    margin: 0 auto;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .searchClassPos {
    position: absolute;
    width: 600px;
    height: 50px;
    top: 250px;
    z-index: 2;
    left: 0px;
    right: 0px;
    margin:auto;
    text-align: center;
    vertical-align:middle;

  }
  .searchClassPos .el-input--suffix .el-input__inner {
    border-left: none;
    height: 50px;
  }

  .searchClassPos-content {
    display: flex;
    flex-direction: row;
    border-radius: 5px
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }

  .spTabList {
    margin: 0 auto;
    display: flex;
    //justify-content: space-between;
    width: 1100px;
    flex-wrap: wrap;
  }
  .cardInfolistmore {
    width: 225px;
    height: 250px;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    margin-top: 40px;
    margin-left: 13px;
    padding: 15px;
    background-color: #F5F8FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/front/splistmore.vue